import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { SettingsLoadingContainer } from 'modules/settings/settings.style';

export const SettingsDevicesConfigurationLayoutLoading: React.FC = () => (
    <SettingsLoadingContainer>
        <PocProgressSpinner variant="primary" size="large" />
    </SettingsLoadingContainer>
);
